import { formatMetricName, isDateValue, inferFormat, formatValue } from './chartUtils';

/**
 * Analiza columnas y clasifica cada una como 'date', 'numeric' o 'string'.
 */
function classifyColumns(keys, rows) {
    const result = {};
    for (const key of keys) {
        const firstValue = rows.find(r => r[key] != null)?.[key];
        if (firstValue !== undefined && isDateValue(String(firstValue))) {
            result[key] = 'date';
        } else if (typeof firstValue === 'number') {
            result[key] = 'numeric';
        } else {
            result[key] = 'string';
        }
    }
    return result;
}

/**
 * Convierte rows flat del agente/template al formato canónico de chart.
 * Input:  [{"Fecha": "20260101", "Costo": 100, "Clicks": 50}, ...]
 *     o:  [{"Costo": 448589, "Canal": "FACEBOOK"}, ...]
 * Output: { labels: ["20260101", ...], series: [{name, label, period, data, formattedData}, ...] }
 *
 * Detecta automáticamente la columna dimensión (primera string/date) en vez de asumir
 * que siempre es la primera key del objeto.
 */
export function reportRowsToChartData(rows) {
    if (!rows || rows.length === 0) return { labels: [], series: [] };

    const keys = Object.keys(rows[0]);
    const types = classifyColumns(keys, rows);

    // La dimensión es la primera columna no-numérica (string o date).
    // Si todas son numéricas, fallback a la primera columna.
    const dimensionKey = keys.find(k => types[k] !== 'numeric') || keys[0];
    const metricKeys = keys.filter(k => k !== dimensionKey && types[k] === 'numeric');

    const labels = rows.map(row => String(row[dimensionKey]));

    const series = metricKeys.map(key => {
        const format = inferFormat(key);
        const data = rows.map(row => row[key] ?? null);
        return {
            name: key,
            label: formatMetricName(key),
            period: 'current',
            data,
            formattedData: data.map(v => v != null ? formatValue(v, format) : null),
        };
    });

    return { labels, series };
}
